import axios from "../../apiFc24";

export const getEvolutionTree = async ({
  resourceId,
  evoPathId,
  playerRoleId,
}: {
  resourceId: number;
  evoPathId?: number;
  playerRoleId?: number;
}) => {
  const params = new URLSearchParams({
    ...(evoPathId ? { "evo-path-id": evoPathId.toString() } : {}),
    ...(playerRoleId ? { "player-role-id": playerRoleId.toString() } : {}),
  });

  const res = await axios.get(
    `/players/${resourceId}/evolution-tree?${params.toString()}`,
  );
  return res.data;
};
